import React from 'react';
import ReactDOM from 'react-dom';
import View from "backdraft-app/src/view";
import Panel from "shared/react_components/Panel";
import WebhookStats from 'shared/react_components/WebhookStats';

/*
  TODO: This file should be removed when the facebook connect app is converted to Webpacker
 */

export default class WebhookStatsPanel extends View {
  render() {
    ReactDOM.render(
      <Panel title="Webhook Health Stats">
        <div className="d-flex">
          <WebhookStats
            fireStats={this.model.get('webhook_fire_stats')}
            lastStatusCode={this.model.get('last_status_code')}
            lastFiredAt={this.model.get('last_fired_at')}
            lastProcessedId={this.model.get('last_processed_transaction_id')}
            lastFailedId={this.model.get('last_failed_transaction_id')}
            lastFailedAt={this.model.get('last_failed_at')}
            lastFailureResponse={this.model.get('last_failure_response_body')}
          />
        </div>
      </Panel>,
      this.el
    );
    return this;
  }
}
